import 'moment/min/locales';

import { Button, CreateAlert, Icon, ITableStructureItem, Table } from 'modules';
import moment from 'moment';
import React, { memo, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';

import { Routes } from '../../../AppRoutes';
import { PopupWraper } from '../../../components/popup';
import { TableFilterInputText } from '../../../components/table-filter-inputs';
import { TableFilterInputSelect } from '../../../components/table-filter-inputs/select';
import { getLocaleKey, translate } from '../../../languages';
import { AdminService } from '../../../services/admin';
import { useSelector } from '../../../store';
import { userWrapper } from '../components';

const CopyToClipboardElement = CopyToClipboard as any;
export const UserList = userWrapper(
  memo(() => {
    const navigate = useNavigate();
    const optionsTimeFilter = [
      { label: 'This Day', value: 'day' },
      { label: 'This Week', value: 'week' },
      { label: 'This Month', value: 'month' },
      { label: 'Custom', value: 'custom' },
    ];

    const [params, setParams] = useState<any>();
    const [currentData, setCurrentData] = useState<any>(null);
    const [editData, setEditData] = useState(null);
    const [freezeDataId, setFreezeDataId] = useState<number | null>(null);
    const [forceUpdateTable, setForceUpdateTable] = useState<boolean>();
    const user = useSelector((state) => state.user);
    const [isShowRangeTime, setIsShowRangeTime] = useState<boolean>(false);
    const [valueSearchFilter, setValueSearchFilter] = useState<any>();
    const [valueDisplayNameFilter, setValueDisplayNameFilter] = useState<any>();
    const [valueTypeFilter, setValueTypeFilter] = useState<any>();
    const [valueTimeFilter, setValueTimeFilter] = useState<any>();
    const [dataLockUser, setDataLockUser] = useState<any>(null);

    const handleConfirmLockUser = (item: any) => {
      AdminService.handleLockUser(
        item?.id,
        item?.isActive === true ? true : false,
      )
        .then((res: any) => {
          CreateAlert({ message: 'Successfully!', type: 'success' });
        })
        .catch((err: any) => {
          CreateAlert({ message: err.message, type: 'danger' });
        })
        .finally(() => {
          setDataLockUser(null);
          setForceUpdateTable((state) => !state);
        });
    };

    const structure: ITableStructureItem[] = [
      // {
      //     name: "UserId",
      //     key: "userId"
      // },
      {
        name: 'AVATAR',
        key: 'avatar',
        render: (item) => (
          <div className='avatar'>
            <img
              className={`avatar__image ${item?.avatar == null ? 'image-error' : ''}`}
              src={item?.avatar ?? '/assets/images/no-image.jpg'}
              onError={(event: any) => {
                if (!event.target.classList.contains('image-error')) {
                  event.target.classList.add('image-error');
                }
                event.target.src = '/assets/images/no-image.jpg';
              }}
              alt=''
              onClick={(event: any) => {
                if (event.target.classList.contains('image-error')) return;
                window.open(item?.avatar, '_blank');
              }}
            />
          </div>
        ),
      },
      {
        name: 'PHONE',
        key: 'phoneNumber',
        render: (item) => {
          return (
            <div className='primary-column'>
              <CopyToClipboardElement
                text={item?.phoneNumber}
                onCopy={() => {
                  CreateAlert({
                    message: translate('Copied'),
                    type: 'success',
                  });
                }}
              >
                <div className='primary-column__wrapper'>
                  <div className='primary-column__content'>
                    {item?.phoneNumber}
                  </div>
                  <div className='primary-column__icon'>
                    <Icon.Copy />
                  </div>
                </div>
              </CopyToClipboardElement>
            </div>
          );
        },
      },
      {
        name: 'NAME',
        key: 'fullName',
        render: (item) => item?.fullName ?? 'N/A',
      },
      {
        name: 'EMAIL',
        key: 'email',
        render: (item) => item?.email ?? 'N/A',
      },
      {
        name: 'ADDRESS',
        key: 'address',
        render: (item) => item?.address ?? 'N/A',
      },
      // {
      //     name: "Last Name",
      //     key: "lastName",
      // },
      // {
      //     name: "Phone",
      //     key: "phoneNumber",
      // },
      {
        name: 'CREATED DATE',
        key: 'createdAt',
        render: (item) =>
          moment(item?.createdAt).locale(getLocaleKey()).format('L HH:mm:ss'),
      },
      // {
      //     name: "Status",
      //     key: "status",
      //     render: (item) => <span className={`status status--${item?.status?.toLowerCase()}`}>{translate(item?.status).toUpperCase()}</span>,
      //     sort: {
      //         descreaseValue: "desc",
      //         increaseValue: "",
      //     },
      // },
      {
        name: 'STATUS',
        key: 'status',
        render: (item) => (
          <span
            className={`status status--${item?.isActive === true ? 'green' : 'red'}`}
          >
            {item?.isActive === true ? 'ACTIVE' : 'BLOCKED'}
          </span>
        ),
      },
      {
        name: 'ACTION',
        key: 'actions',
        render: (item) => {
          return (
            <div className='action'>
              <div
                className='action__edit'
                onClick={() => navigate(Routes.userDetail.renderPath(item?.id))}
              >
                <Icon.ActionEditIcon />
              </div>
              {item?.isActive === true ? (
                <div
                  className='action__lock'
                  onClick={() => setDataLockUser(item)}
                >
                  {/* <Icon.UnlockUserIcon /> */}
                  <div className='action__lock__icon'>
                    <Icon.BlockIcon />
                  </div>
                  <div className='action__lock__text'>BLOCK</div>
                </div>
              ) : (
                <div
                  className='action__unlock'
                  onClick={() => setDataLockUser(item)}
                >
                  {/* <Icon.LockUserIcon /> */}
                  <div className='action__unlock__icon'>
                    <Icon.UnblockIcon />
                  </div>
                  <div className='action__unlock__text'>UNLOCK</div>
                </div>
              )}
            </div>
          );
        },
      },
    ];

    const handleExportExcel = async () => {
      const response = await AdminService.getListTransactions({
        ...params,
        page: 1,
        pageSize: currentData?.count,
      });

      const fileHead = structure
        .map((v) => v.name)
        .filter((v: any) => v != 'ACTION');
      const dataExport = [
        fileHead,
        ...response.data.map((item: any) =>
          structure.map((column, index) => {
            if (!column.key) return '';
            if (column.key === 'status')
              return item?.isActive === true ? 'ACTIVE' : 'BLOCKED';
            return item[column.key];
          }),
        ),
      ];

      const ws = XLSX.utils.aoa_to_sheet(dataExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');

      const now = new Date();
      XLSX.writeFile(
        wb,
        `User List ${now.toLocaleDateString().replace(/\//g, '-')} ${now.toLocaleTimeString().replace(/:/g, '-')}.xlsx`,
        { type: 'binary' },
      );
    };

    return (
      <div className='UserList'>
        <Button
          disabled={!currentData}
          className='mb20'
          label='Export excel'
          buttonType='success'
          onClick={handleExportExcel}
        />

        <Table
          filters={[
            {
              name: 'Search',
              key: 'searchString',
              input: (s) => (
                <TableFilterInputText
                  {...s}
                  value={valueSearchFilter}
                  onChange={(e) => {
                    setValueSearchFilter(e?.searchString);
                    s.onChange(e);
                  }}
                />
              ),
              defaultValue: valueSearchFilter,
            },
            {
              name: 'Display name',
              key: 'name',
              input: (s) => (
                <TableFilterInputText
                  {...s}
                  value={valueDisplayNameFilter}
                  onChange={(e) => {
                    setValueDisplayNameFilter(e?.name);
                    s.onChange(e);
                  }}
                />
              ),
              defaultValue: valueDisplayNameFilter,
            },
            {
              name: 'Type',
              key: 'status',
              input: (s) => (
                <TableFilterInputSelect
                  {...s}
                  options={AdminService.getListUserStatus()}
                  value={valueTypeFilter}
                  onChange={(e) => {
                    setValueTypeFilter(e?.status);
                    s.onChange(e);
                    setForceUpdateTable((state) => !state);
                  }}
                  isClearable={true}
                  isSearchable={false}
                />
              ),
              defaultValue: valueTypeFilter,
            },
            {
              name: 'Time',
              key: 'time',
              input: (s) => (
                <TableFilterInputSelect
                  {...s}
                  options={optionsTimeFilter}
                  value={valueTimeFilter}
                  onChange={(e) => {
                    setValueTimeFilter(e?.time);
                    s.onChange(e);
                    setForceUpdateTable((state) => !state);
                  }}
                  isClearable={true}
                />
              ),
              defaultValue: valueTimeFilter,
            },
            // {
            //   name: "",
            //   key: "created",
            //   input: (s) => (
            //     isShowRangeTime ? <TableFilterRangeTimeInput
            //       {...s}
            //       fromKey="fromDate"
            //       toKey="toDate"
            //     /> : null
            //   )
            // },
          ]}
          structure={structure}
          fetchData={async (params) => {
            setParams(params);
            return AdminService.getListUser({
              page: params.pageNumber,
              pageSize: params.limit,
              ...params,
            }).then((res) => {
              setCurrentData(res);
              return res;
            });
          }}
          forceUpdateTable={forceUpdateTable}
        />
        {dataLockUser && (
          <PopupWraper
            center
            title='Alert'
            onClose={() => setDataLockUser(null)}
          >
            <div className='lock-user-container'>
              <div className='lock-user__title'>
                Are you sure you want to{' '}
                {dataLockUser?.isActive === true ? `lock` : `unlock`} this user?
              </div>
              <div className='lock-user__button-container'>
                <Button
                  className='button__confirm'
                  onClick={() => handleConfirmLockUser(dataLockUser)}
                  label='Confirm'
                  buttonType='success'
                  type='submit'
                />
                <Button
                  className='button__cancel'
                  onClick={() => setDataLockUser(null)}
                  label='Cancel'
                  buttonType='grey'
                />
              </div>
            </div>
          </PopupWraper>
        )}
      </div>
    );
  }),
);
